module.exports = __webpack_public_path__ + "img/brilliante_awaken.bb8f05d2.png";